<div class="inflate" (resize)="onResize()">
    <ng-content></ng-content>
</div>
